import * as React from "react";
import ModelContainer from "../../../components/model/ModelContainer";
import PageTitle from "../../../components/model/PageTitle";
import ModelTitle from "../../../components/model/ModelTitle";
import ModelInfo from "../../../components/model/ModelInfo";
import {GAEventModels} from "../../../utils/SendGAEvent";
import ModelDescription from "../../../components/model/ModelDescription";
import TextSentimentModel from "./TextSentimentModel";
import Disclaimer from "../../../components/model/Disclaimer";
import TabPanel from "../../../components/model/TabPanel";

const TextSentiment = () => {
    return <ModelContainer>
        <PageTitle/>
        <div>
            <ModelTitle>Text Sentiment</ModelTitle>
            <ModelInfo model={GAEventModels.TEXT_SENTIMENT}/>
            <TabPanel
                modelName={GAEventModels.TEXT_SENTIMENT}
                modelDescription={<ModelDescription>Derive the sentiment breakdown of the text.</ModelDescription>}
                content={<TextSentimentModel/>}
            />
            <Disclaimer/>
        </div>
    </ModelContainer>;
};

export default TextSentiment;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/TextSentiment/index.tsx